module.exports = __webpack_public_path__ + "media/images/emblems/Tschappina_wappen-15970b3b4fff0236d22cf4f1bf5cb1f7.svg";